module.exports = __webpack_public_path__ + "static/media/thumbs-down.f0a9848d.svg";